var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.75 56L104.75 41L106.5 21.5L87.25 17L77.25 0L59 7.75L40.75 0L30.75 17L11.5 21.25L13.25 41L0.25 56L13.25 71L11.5 90.5L30.75 95L40.75 112L59 104.25L77.25 112L87.25 95L106.5 90.5L104.75 71L117.75 56ZM48.75 81.25L28.5 60.75L36.5 53L48.75 65.5L80 34L88 42L48.75 81.25Z",
    fill: "#00863F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectGreen);
export default __webpack_public_path__ + "static/media/correct-green.b3651005fdabe21a926cbe2fc3c29dcc.svg";
export { ForwardRef as ReactComponent };